module.exports = __webpack_public_path__ + "img/newsinnerpic.89974c43.jpg";